import { render } from "./FlightCrewReportItemIb.vue?vue&type=template&id=fb50b536"
import script from "./FlightCrewReportItemIb.vue?vue&type=script&lang=js"
export * from "./FlightCrewReportItemIb.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__